import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

/** True when the layout footer (or its SEO block) intersects the viewport — pause infinite listing pagination. */
export interface FooterVisibilityState {
  isInViewport: boolean;
}

const initialState: FooterVisibilityState = {
  isInViewport: false,
};

const footerVisibilitySlice = createSlice({
  name: 'footerVisibility',
  initialState,
  reducers: {
    setFooterInViewport(state, action: PayloadAction<boolean>) {
      state.isInViewport = action.payload;
    },
  },
});

export const { setFooterInViewport } = footerVisibilitySlice.actions;
export const footerVisibilityReducer = footerVisibilitySlice.reducer;

/** Structural typing avoids a circular import with `store.ts`. */
export function selectFooterInViewport(state: { footerVisibility?: FooterVisibilityState }): boolean {
  return state.footerVisibility?.isInViewport ?? false;
}
